<script setup>
import { ref, onMounted } from 'vue';
const props = defineProps(['title', 'id', 'startOpen']);
const isOpen = ref(!!props.startOpen);
function toggle() {
  isOpen.value = !isOpen.value;
}
</script>
<template>
  <div class="accordion-item" :class="{ open: isOpen }" :id="id">
    <div class="accordion-header">
      <span class="accordion-title" @click="toggle">{{ title }}</span>
      <slot name="header-actions"></slot>
    </div>
    <div class="accordion-content">
      <slot></slot>
    </div>
  </div>
</template>
